import React, { useState, useEffect } from "react";
import { Icon, useToast } from "@chakra-ui/react";
import { FiEdit3 } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { BsCheckCircle } from "react-icons/bs";
import { arrayToOption } from "../../../Utils/formatUtils";
import ResponsiveRow from "../../Common/Table/ResponsiveRow";
import TdType from "../../Common/Table/TdType";

const ProductItem = ({
  product,
  setShowNewProduct,
  initialAction = "row",
  addProduct,
  updateProduct,
  deleteProductHandler,
  isEditable = true,
  products,
  setIsEdited = () => {},
}) => {
  const [action, setAction] = useState(initialAction);
  const [newProduct, setNewProduct] = useState(product);
  const [productsOptions, setProductsOptions] = useState([]);
  const toast = useToast();

  useEffect(() => {
    setNewProduct(product);
    if (action === "new" || action === "edit") setIsEdited(true);
  }, [action]);

  useEffect(() => {
    setProductsOptions(arrayToOption(products, "id", "productName"));
  }, []);

  const validateForm = async () => {
    if (!newProduct.id || !newProduct.cost || !newProduct.qty) {
      toast({
        title: "Se ha producido un error.",
        description: "Verifique todos los campos",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } else {
      let product = { ...newProduct };
      switch (action) {
        case "edit":
          await updateProduct(product);

          break;

        case "new":
          await addProduct(product);

          break;
      }
      setShowNewProduct(false);
      setAction("row");
    }
  };

  const handleCancel = () => {
    setAction("row");
  };

  const handleSwitchChange = (val) => {
    setNewProduct({
      ...newProduct,
      [val.target.id]: val.target.checked ? 1 : 0,
    });
  };

  const handleChange = (val) => {
    setNewProduct({ ...newProduct, [val.target.id]: val.target.value });
  };

  const handleEdit = () => {
    setAction("edit");
  };

  const handleSubmit = () => {
    validateForm();
  };

  const handleProductChange = (val) => {
    if (val !== null) {
      let cost = products.find((product) => val.value == product.id).cost;

      setNewProduct({
        ...newProduct,
        productName: val.label,
        id: val.value,
        cost: cost,
        updateStock: 1,
        updateCost: 0,
      });
    }
  };

  const rowDisplay = () => {
    let rowData = [];
    // eslint-disable-next-line default-case
    switch (action) {
      case "edit":
        rowData = [
          {
            item: <TdType text={product.productName} />,
          },
          {
            tdStyle: { width: "10%" },
            item: (
              <TdType
                inputType="input"
                isDisabled={!newProduct.id}
                id="qty"
                type="number"
                onWheel={(e) => e.target.blur()}
                value={newProduct.qty}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: { textAlign: "center", width: "15%" },
            item: (
              <TdType
                inputType="input"
                isDisabled={!newProduct.id}
                id="cost"
                type="number"
                onWheel={(e) => e.target.blur()}
                fontSize="1em"
                borderColor="cornflowerblue"
                value={newProduct.cost}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: { textAlign: "center" },
            item: (
              <TdType
                inputType="switch"
                id="updateStock"
                isChecked={newProduct.updateStock}
                onChange={handleSwitchChange}
              />
            ),
          },
          {
            tdStyle: { textAlign: "center" },
            item: (
              <TdType
                inputType="switch"
                id="updateCost"
                isChecked={newProduct.updateCost}
                onChange={handleSwitchChange}
              />
            ),
          },
          {
            tdStyle: { textAlign: "center", fontSize: "1.5em", width: "15%" },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => handleCancel(false)}
                ></Icon>
              </>
            ),
          },
        ];
        return (
          <ResponsiveRow key={newProduct.id} cells={rowData}></ResponsiveRow>
        );

      case "new":
        rowData = [
          {
            tdStyle: { width: "25%" },
            item: (
              <TdType
                inputType="modal"
                name={`productName`}
                id={`productName`}
                title={"Elija un artículo"}
                modalTitle={"Listado de artículos"}
                placeholder={"Elija un artículo"}
                options={productsOptions}
                value={productsOptions.find(
                  (item) => item.value == newProduct.id
                )}
                onChange={(val) => handleProductChange(val)}
              />
            ),
          },
          {
            tdStyle: { width: "10%" },
            item: (
              <TdType
                inputType="input"
                isDisabled={!newProduct.id}
                id="qty"
                type="number"
                onWheel={(e) => e.target.blur()}
                value={newProduct.qty}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: { textAlign: "center", width: "15%" },
            item: (
              <TdType
                inputType="input"
                isDisabled={!newProduct.id}
                id="cost"
                type="number"
                onWheel={(e) => e.target.blur()}
                fontSize="1em"
                borderColor="cornflowerblue"
                value={newProduct.cost}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: { textAlign: "center" },
            item: (
              <TdType
                inputType="switch"
                id="updateStock"
                isChecked={newProduct.updateStock}
                onChange={handleSwitchChange}
              />
            ),
          },
          {
            tdStyle: { textAlign: "center" },
            item: (
              <TdType
                inputType="switch"
                id="updateCost"
                isChecked={newProduct.updateCost}
                onChange={handleSwitchChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => setShowNewProduct(false)}
                ></Icon>
              </>
            ),
          },
        ];
        return (
          <ResponsiveRow key={newProduct.id} cells={rowData}></ResponsiveRow>
        );

      case "row":
        rowData = [
          {
            item: <TdType text={product.productName} />,
          },
          {
            item: <TdType text={product.qty} />,
          },
          {
            item: <TdType text={product.cost} />,
          },
          {
            tdStyle: { textAlign: "center" },
            item: (
              <TdType
                inputType="switch"
                id="updateStock"
                isDisabled={true}
                isChecked={product.updateStock}
              />
            ),
          },
          {
            tdStyle: { textAlign: "center" },
            item: (
              <TdType
                inputType="switch"
                id="updateCost"
                isDisabled={true}
                isChecked={product.updateCost}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                <Icon
                  mx="2"
                  as={FiEdit3}
                  _hover={{ cursor: isEditable ? "pointer" : "not-allowed" }}
                  onClick={() => isEditable && handleEdit(product)}
                  title={"Editar"}
                ></Icon>

                <Icon
                  as={FiTrash2}
                  _hover={{ cursor: isEditable ? "pointer" : "not-allowed" }}
                  mx="2"
                  title="Eliminar"
                  onClick={() => isEditable && deleteProductHandler(product)}
                />
              </>
            ),
          },
        ];
        return <ResponsiveRow key={product.id} cells={rowData}></ResponsiveRow>;
    }
  };

  return rowDisplay();
};

export default ProductItem;
